import React from 'react';

import { Footer, Header, PageLayout } from '../../components';
import PageContent from '../../features/CrtsDetails';
import { useAuthValidation } from '../../utils/hooks';

const CrtDetailPage = () => {
  useAuthValidation();

  return (
    <>
      <Header />
      <PageLayout>
        <PageContent />
      </PageLayout>
      <Footer />
    </>
  );
};

export default CrtDetailPage;
